if (!customElements.get('info-card-slider')) {
  class InfoCardSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.carousel__slide'));
      if (!this.slides.length) return;

      this.desktopQuery = window.matchMedia('(min-width: 768px)');
      this._onBreakpointChange = this.build.bind(this);
      this._updateFocus = this.updateFocus.bind(this);
      this.toggleBreakpointListener(true);

      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          if (this.flkty && this.slides.indexOf(event.target) > -1) {
            this.flkty.selectCell(event.target, false, true);
          }
        });
      }

      if (typeof Flickity === 'undefined') {
        window.addEventListener('load', this._onBreakpointChange, { once: true });
        return;
      }
      this.build();
    }

    disconnectedCallback() {
      if (this.desktopQuery && this._onBreakpointChange) {
        this.toggleBreakpointListener(false);
      }
      this.destroy();
    }

    toggleBreakpointListener(add) {
      const mql = this.desktopQuery;
      if (mql.addEventListener) {
        mql[add ? 'addEventListener' : 'removeEventListener']('change', this._onBreakpointChange);
      } else {
        mql[add ? 'addListener' : 'removeListener'](this._onBreakpointChange);
      }
    }

    build() {
      if (typeof Flickity === 'undefined') return;

      const desktop = this.desktopQuery.matches;
      const focusCount = desktop ? 2 : 1;
      if (this.flkty && this.focusCount === focusCount) return;

      this.destroy();
      this.focusCount = focusCount;

      this.flkty = new Flickity(this, {
        cellSelector: '.carousel__slide',
        cellAlign: desktop ? 1 / 3 : 'center',
        wrapAround: true,
        autoPlay: parseInt(this.dataset.autoplay, 10) || false,
        pageDots: this.slides.length > 1,
        prevNextButtons: false,
        draggable: this.slides.length > focusCount,
        rightToLeft: document.dir === 'rtl'
      });

      const prev = this.querySelector('.flickity-prev');
      const next = this.querySelector('.flickity-next');
      if (prev) prev.onclick = () => this.step(-focusCount);
      if (next) next.onclick = () => this.step(focusCount);

      this.flkty.on('ready', this._updateFocus);
      this.flkty.on('scroll', this._updateFocus);
      this.flkty.on('settle', this._updateFocus);
      this.updateFocus();

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          if (!this.flkty) return;
          this.flkty.resize();
          this.updateFocus();
        });
      }
    }

    step(amount) {
      if (this.flkty) this.flkty.select(this.flkty.selectedIndex + amount, true);
    }

    updateFocus() {
      if (!this.flkty) return;

      const viewport = this.querySelector('.flickity-viewport') || this;
      const rect = viewport.getBoundingClientRect();
      const center = rect.left + rect.width / 2;

      const nearest = this.slides
        .map((el) => {
          const r = el.getBoundingClientRect();
          return { el: el, offset: Math.abs(r.left + r.width / 2 - center), width: r.width };
        })
        .filter((item) => item.width > 0)
        .sort((a, b) => a.offset - b.offset)
        .slice(0, this.focusCount)
        .map((item) => item.el);

      this.slides.forEach((el) => {
        el.classList.toggle('is-focused', nearest.indexOf(el) > -1);
      });
    }

    destroy() {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }
      this.focusCount = null;
    }
  }

  customElements.define('info-card-slider', InfoCardSlider);
}
